<template>
    <div
            class="modal fade"
            id="addammeter_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">添加电表</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">电表编号</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="ammeterInfo.numbering"/>
                            </div>
                            <label class="col-sm-3 control-label">电表位置</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="ammeterInfo.position"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label">电表类型</label>
                            <div class="col-sm-3">
                                <select
                                        name
                                        class="chosen-select_1"
                                        id
                                        placeholder="请选择电表类型"
                                        v-model="ammeterInfo.category"
                                >
                                    <option
                                            v-for="(item,index) in categoryList"
                                            :key="index"
                                            :value="item.value"
                                    >{{item.name}}
                                    </option>
                                </select>
                            </div>
                            <label class="col-sm-3 control-label ammeterModel" style="display:none;">电表型号</label>
                            <div class="col-sm-3 ammeterModel" style="display:none;">
                                <select
                                        name
                                        class="chosen-select_2"
                                        placeholder="请选择电表型号"
                                        v-model="ammeterInfo.model"
                                >
                                    <option v-for="(item,index) in modelList" :key="index" :value="item">{{item}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group uploadFile">
                            <div class="col-sm-3 control-label">上传照片</div>
                            <div class="col-sm-3">
                                <input
                                        type="file"
                                        class="form-control file-pretty_addAmmeter"
                                        id="addAmmeterPic"
                                        @change="addAmmeterPic('addAmmeterPic')"
                                />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label">经度</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="ammeterInfo.longitude"/>
                            </div>
                            <label class="col-sm-3 control-label">纬度</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="ammeterInfo.latitude"/>
                            </div>
                        </div>
                        <span class="tips">***请在地图上拖动图标选择电表位置***</span>
                        <div id="addammeterMap" name></div>
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submit">提交</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import AMap from 'AMap'

  var map
  var marker
  export default {
    data () {
      return {
        showModel: true, // 是否显示选择电表型号
        categoryList: [
          {
            name: 'A 在用分表',
            value: 'A'
          },
          {
            name: 'B 在用总表',
            value: 'B'
          },
          {
            name: 'C 智能分表',
            value: 'C'
          },
          {
            name: 'D 智能总表',
            value: 'D'
          },
          {
            name: 'Z 临时表',
            value: 'Z'
          },
          {
            name: 'X 未知类型',
            value: 'X'
          }
        ], // 电表类型
        modelList: ['DDZY251-NB'], // 电表型号
        ammeterInfo: {
          numbering: '', // 电表编号
          longitude: '', //  位置经度
          latitude: '', // 位置纬度
          position: '', //电表位置
          category: '', // 电表分类
          model: 'DDZY251-NB', // – 电表类型
          picture: '' // 后台返回的图片上传路径
        }
      }
    },
    props: ['msgStation'],
    mounted: function () {
      $('.file-pretty_addAmmeter').prettyFile()
    },
    methods: {
      getData: function () {
        console.log('加载添加电表页面')
        console.log('基站信息---', this.msgStation)
        var self = this
        // 信息初始化
        self.ammeterInfo = {
          numbering: '', // 电表编号
          longitude: '', //  位置经度
          latitude: '', // 位置纬度
          position: '', //电表位置
          category: '', // 电表分类
          model: 'DDZY251-NB' // – 电表类型
        }
        self.ammeterInfo.longitude = self.msgStation.stst_longitude
        self.ammeterInfo.latitude = self.msgStation.stst_latitude
        map = new AMap.Map('addammeterMap', {
          resizeEnable: true,
          center: [self.msgStation.stst_longitude, self.msgStation.stst_latitude],
          zoom: 13
        })
        marker = new AMap.Marker({
          position: map.getCenter(),
          offset: new AMap.Pixel(-13, -30),
          draggable: true
        })
        marker.setMap(map)
        $('.chosen-select_1').val('').trigger('chosen:updated')
        $('.chosen-select_2').val('').trigger('chosen:updated')
        $('.chosen-select_1')
          .chosen({
            disable_search_threshold: 10,
            disable_search: true,
            width: '100%'
          })
          .change(function () {
            self.ammeterInfo.category = $('.chosen-select_1').val()
            if (
              $('.chosen-select_1').val() == 'C' ||
              $('.chosen-select_1').val() == 'D'
            ) {
              $('.ammeterModel').show()
              self.ammeterInfo.model = 'DDZY251-NB'
            } else {
              $('.ammeterModel').hide()
              self.ammeterInfo.model = ''
            }
          })
        $('.chosen-select_2')
          .chosen({
            disable_search_threshold: 10,
            disable_search: true,
            width: '100%'
          })
          .change(function () {
            self.ammeterInfo.model = $('.chosen-select_2').val()
            console.log($('.chosen-select_2').val())
          })
      },
      addAmmeterPic: function () {
        // 上传返回file_path;
        var self = this
        self.global.uploadfile(
          self,
          'addAmmeterPic',
          function (res) {
            console.log(res)
            if (res.status == 'success') {
              // console.log(res.file_path);
              self.ammeterInfo.picture = res.file_path
            } else {
              alert('图片上传失败')
            }
          },
          function () {
            alert('图片上传失败')
          }
        )
      },
      submit: function () {
        var self = this
        console.log(self.ammeterInfo)
        self.ammeterInfo.longitude = marker.getPosition().getLng()
        self.ammeterInfo.latitude = marker.getPosition().getLat()
        if (self.ammeterInfo.numbering.replace(/\s+/g, '') == '') {
          alert('必须输入电表编号')
          return
        }
        if (self.ammeterInfo.position.replace(/\s+/g, '') == '') {
          alert('必须输入电表位置')
          return
        }

        if (self.ammeterInfo.category == '') {
          alert('必须选择电表类型')
          return
        }

        console.log(self.ammeterInfo)

        self.global.axiosPost(
          self,
          'station/' + self.msgStation.stst_atpid + '/ammeters/',
          self.ammeterInfo,
          function (res) {
            console.log(res)
            if (res.status == 'success' && !res.message) {
              alert('添加成功')
            }
            if (res.status == 'success' && res.message == 'submitted') {
              alert('已提交审核')
            }
            if (res.status == 'error') {
              alert(res.message)
            }
            $('#addammeter_modal').modal('hide')
          },
          function (res) {
            console.log('操作失败--', res)
            alert('添加失败:' + res.response.data.message)
          }
        )
      }
    }
  }
</script>
<style scoped>
    #addammeterMap {
        width: 100%;
        height: 300px;
    }

    .tips {
        color: red;
        float: right;
        padding-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/stationmanager/addammeter.vue